export const AI_MATE_ATTRIBUTES = {
	conversationChannelId: 'conversationChannelId',
	experienceId: 'experienceId',
	product: 'product',
	agentId: 'agentId',
	fullScreen: 'fullScreen',
} as const;

export type AIMateAttributeType = {
	[AI_MATE_ATTRIBUTES.conversationChannelId]: string;
	[AI_MATE_ATTRIBUTES.experienceId]: string;
	[AI_MATE_ATTRIBUTES.product]: string;
	[AI_MATE_ATTRIBUTES.agentId]: string | null;
	[AI_MATE_ATTRIBUTES.fullScreen]: boolean;
};

export type AnalyticsPropertiesContextProps = {
	propertiesRef: React.MutableRefObject<AIMateAttributeType>;
	setAnalyticsPropertiesWithoutRerender: (properties: Partial<AIMateAttributeType>) => void;
};
